/**
 * Citation rendering in chat answers. `true` → verbose source pills (filename + page).
 * `false` → compact, clickable `[n]` markers (state-of-the-art reference style); clicking still
 * opens the source in the drawer. Flip to `false` to trial the lighter format.
 */
export const SHOW_CITATION_PILLS_FEATURE_FLAG = true;

/**
 * Optional gate for the ChatOptions tray (citation-mode control, etc.). Currently NOT wired —
 * ChatOptions renders for everyone, hidden behind its own collapse toggle. Wrap <ChatOptions /> in
 * this flag if/when the controls should be restricted to certain users.
 * (Server-side role-gating of the control itself is a separate follow-up — see rag/routes.py.)
 */
export const SHOW_CITATION_MODE_CONTROL_FEATURE_FLAG = false;

export const SHOW_SUGGESTIONS_FEATURE_FLAG = false;
export const SHOW_IMPORTANT_QUERY_FEATURE_FLAG = false;

/**
 * Hide tabs from chat (concern is suggestions are very hit and miss in
 * current form and will provide bad answers)
 */
export const SHOW_TABS_IN_CHAT_FEATURE_FLAG = SHOW_SUGGESTIONS_FEATURE_FLAG || SHOW_IMPORTANT_QUERY_FEATURE_FLAG;
